import styled from 'styled-components';
import config from '@/config';

const NoticeBanner = styled.div`
  background-color: rgba(108, 75, 202, 0.9);
  color: white;
  font-weight: 600;
  padding: 1em;
  text-align: center;
  line-height: 2em;
`;

const NetworkLogo = styled.img`
  height: 1.5em;
  width: 1.5em;
  display: inline-block;
`;

const NewNetworksBanner = () => {
  if (config.commerceEnv !== 'production') {
    return null;
  }

  return (
    <NoticeBanner>
      🔥 We&apos;ve recently added support for Initia <NetworkLogo src="https://assets.bidali.com/networks/small/initia.png" />, Sui <NetworkLogo src="https://assets.bidali.com/networks/small/sui.png" />, Aptos <NetworkLogo src="https://assets.bidali.com/networks/small/aptos.png" />, Berachain <NetworkLogo src="https://assets.bidali.com/networks/small/berachain.png" />, and Sonic <NetworkLogo src="https://assets.bidali.com/networks/small/sonic.png" />
    </NoticeBanner>
  );
};

export default NewNetworksBanner;
